// @flow

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Logout from './logout';
import { User } from '../../models/user';

export type Props = {
  user: User,
  fetching: boolean,
  authenticating: boolean,
};

const mapState = ({ authentication }) => ({
  user: authentication.user,
  authenticating: authentication.authenticating,
});

const mapDispatch = {};

export default withRouter(
  connect(
    mapState,
    mapDispatch,
  )(Logout),
);
